import actions from './actions';
const initState = {
  informeGeneral:null,
  prevUrl:null
}
export default function telepaseReducer(state=initState, action){
  switch (action.type) {
    case actions.CLEAR_INFORME_GENERAL:
      return { ...initState };
    case actions.SET_INFORME_GENERAL:
      return { ...state, informeGeneral:action.payload};
    case actions.SET_URL:
      return { ...state, prevUrl:action.payload};
    default:
      return state
  }
}
